<div id="managePopUp">

  <div *ngIf="isSingleFlow && !isMaxReach">
    <div class="modal-header">
      <div class="modal-title">{{authoringContentData?.transferNumber}}</div>
      <button type="button" class="close" aria-label="Close" (click)="closeWithXBtn()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" *ngFor="let line of selectedLines">
      <div class="modal-subtitle">
        <span id="old-number">{{line?.msisdn | phone}}</span>
      </div>
      <div class="row clearfix">
        <div class="col-12 col-md-6 m-b-35">
          <div class="addGroupText">
            <input type="text" appPhoneMask class="addGroup-input"
              maxlength="14" required [(ngModel)]="tranNumber" minlength="10"
              [ngClass]="{'success': (errorOrSuccessMessage && eligiblilityCalled), 'error': (errorOrSuccessMessage == false && eligiblilityCalled) || (transferNum.errors?.minlength && transferNum.touched)}"
              oninput="this.value = this.value.replace(/[^0-9]/g, '');" (blur)="getNumberEligibilty(tranNumber)" (keyup)="checkInputChange()" #transferNum="ngModel">          
              <div class="displayErrorInline" *ngIf="transferNum.errors?.minlength && transferNum.touched">
              {{authoringContentData?.errorMsgNumberTransfer}}</div>
              <div *ngIf="eligiblilityCalled && !transferNum.errors?.minlength" 
              [ngClass]="{'displaySuccessInline': errorOrSuccessMessage, 'displayErrorInline': !errorOrSuccessMessage}">
                <div *ngIf="!errorOrSuccessMessage">
                  {{authoringContentData?.numberToTransferError}}</div>
            
                  <div *ngIf="errorOrSuccessMessage">
                    {{authoringContentData?.numberToTransferSuccess}}</div>            
              </div>           
            <span class="floating-label">{{authoringContentData?.tnNumberPlaceholder}}<span
                class="asterisk">{{authoringContentData?.asterisk}}</span></span>
          </div>
        </div>
      </div>
  
      <div class="row clearfix">
        <div class="col-12 col-md-6 m-b-35">
          <div class="addGroupText">
            <div class="date_label">
              <div class="datepic_box">
                <input type="text" readonly class="datepicker addGroup-input" name="dp" [(ngModel)]="portInDate"
                  ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle();" [maxDate]="maximumTransferDate"
                  [minDate]="minimumTransferDate" (dateSelect)="getNumberEligibilty(tranNumber);" />
                <span class="helpTxt p-t-5">{{authoringContentData?.portDateHelpText}}</span>
                <span class="floating-label">{{authoringContentData?.transferNumberDateTxt}}<span
                    class="asterisk">{{authoringContentData?.asterisk}}</span></span>
                <span class="box_icon date_iocn" (click)="d1.toggle();"
                  (dateSelect)="getNumberEligibilty(tranNumber);"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row greyBg mb-4">
        <div class="col-12">
          <p class="mb-0"> {{authoringContentData?.transferNumberGreySection}}</p>
        </div>
        <div class="col-12 col-md-6">
          <div class="u--marginTop">
            <div class="addGroupText">
              <input type="text" class="addGroup-input" [ngClass]="{'error': isValidAcNumber === false}" minlength="1"
                maxlength="30" required="" [(ngModel)]="accountNumber"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');"
                (blur)="getNumberEligibilty(tranNumber, accountNumber)"
                (change)="getErrorMessageAccountNumber(accountNumber, portInDate)">
              <span class="floating-label">{{authoringContentData?.transferNumberAccountNumberText}}<span
                  class="asterisk">{{authoringContentData?.asterisk}}</span></span>
            </div>
          </div>
        </div>
  
        <div class="col-12 col-md-6">
          <div class="u--marginTop">
            <div class="addGroupText">
              <input type="password" class="addGroup-input" minlength="1" maxlength="30" required=""
                [(ngModel)]="accountPassword" #acPassPin
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');" />
              <span class="fa" [ngClass]="acPassPin.type === 'password' ? 'fa-eye-slash' : 'fa-eye' "
                (click)="toggleText(acPassPin)"></span>
              <span class="fa fa-question-circle" ngbTooltip="Most carriers require a password or PIN to port your number"
                placement="left"></span>
              <div class="displayErrorInline" *ngIf="">{{authoringContentData?.errorMsgNumberTransfer}}</div>
              <span class="floating-label">{{authoringContentData?.transferNumberAccountPasswordText}}</span>
  
            </div>
          </div>
        </div>
  
      </div>
      <div class="row">
        <div class="col-12 businessAdvisemen">
          <h5>{{authoringContentData?.tnBusinessAdtext}}</h5>
          <p class="mb-0" [innerHTML]="this.authoringContentData.tnBusinessAdswriteUp"></p>
        </div>
      </div>
    </div>
    <div class="text-right">
      <button type="button" class="col-12 primary_btn" (click)="submitTransferNumberRequest()"
        [disabled]="isDisabled || isDisabledAcNo || isDisabledDate || !errorOrSuccessMessage || isSubmitReadOnly">{{authoringContentData?.submitTxt}}</button>
    </div>
  </div>

  <div *ngIf="!isSingleFlow && !isMaxReach">
    
    <div class="modal-header">
      <div class="modal-title">{{authoringContentData?.multilinePortInHeader}}{{selectedLines.length}})</div>
      <button type="button" class="close" aria-label="Close" (click)="closeWithXBtn()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="sub-text">
      <mat-checkbox (change)="showCarrierNumber($event)">
        {{authoringContentData?.transferNumberMultiLineTxt}}
      </mat-checkbox>
      <div class="row clearfix m-b-10" *ngIf="showCarrier" >
        <div class="col-6 mb-4 mt-4">
          <div class="addGroupText">
            <input type="text" class="addGroup-input" maxlength="30" required=""
              [(ngModel)]="allCarrierNumber" (blur)="populateCarrierNumber(allCarrierNumber)"/>
            <span class="floating-label">{{authoringContentData?.carrierNumberPlaceholder}}</span>
          </div>
        </div>
        <div class="col-6 m-b-35"></div>
      </div>
    </div>
    <hr>

    <div class="modal-body p-0 scroll-body">
      <div class="success-issues-block">
        
          <mat-accordion *ngFor="let line of selectedLines; let i=index;">
            <mat-expansion-panel (afterExpand)="matPanelOpenCloseClickTag('Expand')" (closed)="matPanelOpenCloseClickTag('Collapse')" [expanded]="line.expendFlagValue" class="panel-overflow-portin">
              <mat-expansion-panel-header class="specific-class">
                <mat-panel-title class="accordion-txt">
                  <span class="issueIcon"
                    *ngIf="line.isAccordionValidated === false || (line.isValidNumberToTfr === false || line.errorOrSuccessMessage === false) || line.isCarrierNumberValid === false || 
                    line.isPortTimeValid === false"></span>
                  <span class="successIcon"
                    *ngIf="line.isAccordionValidated === true && (line.isValidNumberToTfr === true && line.errorOrSuccessMessage === true) && line.isCarrierNumberValid === true && 
                    line.isPortTimeValid === true"></span>
                  <span>{{line['msisdn'] | phone}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row clearfix m-b-10">
                <div class="col-7 m-b-35">
                  <div class="addGroupText">
                    <input type="text" appPhoneMask class="addGroup-input" maxlength="14" required=""
                      [(ngModel)]="line.tranNumber" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      (blur)="getNumberEligibiltyForMultiLine(line)"
                      [ngClass]="{'success': line.errorOrSuccessMessage === true && line.isValidNumberToTfr != false, 'error': line.errorOrSuccessMessage === false && line.isValidNumberToTfr === false}"
                      >
                      <div class="displayErrorInline" *ngIf="line.isValidNumberToTfr === false">
                        {{authoringContentData?.errorMsgNumberTransfer}}</div>
                      <div class="displaySuccessInline" *ngIf="line.errorOrSuccessMessage && line.isValidNumberToTfr != false">
                        {{authoringContentData?.numberToTransferSuccess}}</div>
                      <div class="displayErrorInline" *ngIf="line.errorOrSuccessMessage === false && line.isValidNumberToTfr != false">
                        {{authoringContentData?.numberToTransferError}}</div>
                    <span
                      class="floating-label">{{authoringContentData?.tnNumberPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-5 m-b-35"></div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-7 m-b-35">
                  <div class="addGroupText">
                    <input type="text" class="addGroup-input" maxlength="30" required=""
                      [(ngModel)]="line.carrierNumber" (change)="validateAccountNumber(line)"
                      [ngClass]="{'error': line.carrierNumber.length > 30}"/>
                    <div class="displayErrorInline" *ngIf="line.carrierNumber.length > 30">
                      {{authoringContentData?.invalidCarrierNumberErrMsg}}</div>
                    <span
                      class="floating-label">{{authoringContentData?.carrierNumberPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-6 m-b-35"></div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-7 m-b-35">
                  <div class="addGroupText">
                    <input type="password" class="addGroup-input" minlength="1" maxlength="30" required="" #acPassPin
                      [(ngModel)]="line.accountPinPass" />
                    <span class="fa" [ngClass]="acPassPin.type === 'password' ? 'fa-eye-slash' : 'fa-eye' "
                      (click)="toggleText(acPassPin)"></span>
                    <span
                      class="floating-label">{{authoringContentData?.accountPinPasswordPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-5 m-b-20 infoBlock d-flex align-items-start">
                  <img src="/assets/tfb-acctmgmt/images/icons/information.svg" class="m-r-10" alt="Info">
                  <p class="small-text">{{authoringContentData?.accountPinPasswordHelpText}}</p>
                </div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-7 m-b-35">
                  <div class="addGroupText">
                    <div class="date_label">
                      <div class="datepic_box" (click)="calendarClickTag()">
                        <input type="text" class="datepicker addGroup-input" readonly name="dp" ngbDatepicker
                          #d1="ngbDatepicker" [maxDate]="maximumTransferDate" [minDate]="minimumTransferDate"
                          (click)="d1.toggle()" [(ngModel)]="line.portDate"
                          (dateSelect)="getNumberEligibiltyForMultiLine(line)" 
                          [ngClass]="{'error':line.missingPortDate == true }" />
                          
                        <div class="displayErrorInline" *ngIf="line.missingPortDate === true || !line.portDate">
                          {{authoringContentData?.missingPortDateErrMsg}}</div>
                        <span
                          class="helpTxt p-t-5">{{authoringContentData?.portDateHelpText}}</span>
                        <span
                          class="floating-label">{{authoringContentData?.transferNumberDateTxt}}</span>
                        <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5 m-b-20 infoBlock d-flex align-items-start">
                  <img src="/assets/tfb-acctmgmt/images/icons/information.svg" class="m-r-10 mt-1" alt="Info">
                  <p class="small-text">{{authoringContentData?.portDateInfoMsg}}</p>
                </div>
              </div>


              <div class="row clearfix m-b-10">
                <div class="col-6">
                  <a class="remove_number_link"
                    (click)="removeTransferNumber(line)">{{authoringContentData?.removeNumberTxt}}</a>
                </div>
                <div class="col-6"></div>
              </div>

            </mat-expansion-panel>
            <hr />
          </mat-accordion>
      </div>
      <div class="row">
        <div class="col-12 businessAdvisemen">
          <h5>{{authoringContentData?.businessAdvisementsTitle}}</h5>
          <p class="mb-0" [innerHTML]="authoringContentData.tnBusinessAdswriteUp"></p>
        </div>
      </div>

    </div>
    <hr class="mt-0">
    <div class="modal-footer justify-content-end">
      <div class="d-flex flex-column flex-md-row justify-content-end">
        <button type="button" class="secondary_btn m-r-10 m-b-10"
          (click)="closeWithCancelBtn()">{{authoringContentData?.cancelTxt}}</button>
        <button type="button" class="primary_btn m-b-10" [disabled]="!enableSubmitBtn || isSubmitReadOnly"
          (click)="submitTransferNumberRequest()">{{authoringContentData?.submitTxt}}</button>
      </div>
    </div>
  </div>

  <div *ngIf="isMaxReach">
    <div class="modal-header justify-content-start">
      <h4 class="modal-title mt-0" id="modal-basic-title">{{header}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="generateMaxAttemptsXTag()">
       <span> <img src="/assets/tfb-acctmgmt/images/icons/close-icon.png" alt=""></span>
      </button>
    </div> 
    <div class="modal-body">
      <div class="row m-0">
        <div class="addGroup-label">
          <p class="errBodyTxt">{{msg}}</p>
        </div>
      </div>
    </div>
    <div class="text-right">
      <button type="button" class="col-12 primary_btn" (click)="generateMaxAttemptsDoneTag()"
        >{{authoringContentData?.doneCTA}}</button>
    </div>
  </div>

</div>